import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/00_loghi_landing/bianchi/terzjus_chiaro.png")